module.exports = __webpack_public_path__ + "static/img/img-honda-vario.8337c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-honda-vario.png
// module id = 28J7
// module chunks = 36